import React from 'react';

import { FactureAchat, useAchatsService, useSociete } from '@europrocurement/l2d-domain';
import { Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import { FactureAchatApiSyncG3FactureAchatFactureAchatItemRequest } from '@europrocurement/l2d-domain/openApi/ApiAchats';

export const useSyncG3 = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { factureAchatApi } = useAchatsService();
    const xIdSociete = useSociete();

    const synchroG3Facture = React.useCallback(
        async (factureAchat: FactureAchat, forced: boolean = true, idSociete?: number) => {
            if (!factureAchat.id) {
                enqueueSnackbar(
                    <Typography>
                        Erreur technique la facture n&apos;a pas d&apos;identifiant
                    </Typography>,
                    { variant: 'warning' },
                );
                return Promise.reject();
            }
            try {
                const requestParameters: FactureAchatApiSyncG3FactureAchatFactureAchatItemRequest =
                    {
                        xIdSociete: idSociete ?? xIdSociete,
                        id: `${factureAchat.id}`,
                        factureAchatJsonldFactureAchatSyncG3: { syncG3: true, forced },
                    };

                const res =
                    await factureAchatApi.syncG3FactureAchatFactureAchatItem(requestParameters);

                if (res.status >= 200 && res.status < 300) {
                    enqueueSnackbar(<Typography>Synchronisation en cours</Typography>, {
                        variant: 'success',
                    });
                    return Promise.resolve();
                }
                throw new Error(`Erreur ${res.status}`);
            } catch (error) {
                if (
                    error instanceof AxiosError &&
                    error.response &&
                    error.response.data.exception &&
                    error.response.data.exception.message
                ) {
                    enqueueSnackbar(
                        <Typography>{error.response.data.exception.message}</Typography>,
                        {
                            variant: 'error',
                        },
                    );
                } else if (error instanceof Error) {
                    enqueueSnackbar(<Typography>{error.message}</Typography>, {
                        variant: 'error',
                    });
                }
                return Promise.reject();
            }
        },
        [enqueueSnackbar, factureAchatApi, xIdSociete],
    );

    return { synchroG3Facture };
};
